/*
 * @Author: your name
 * @Date: 2020-09-02 10:02:38
 * @LastEditTime: 2020-11-03 09:37:14
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /joyreserve-phoenix/src/models/order.ts
 */
import { createModel } from '@rematch/core'
import { Configure } from 'types/app'
import { Tab } from 'types/order'

interface OrderState {
  selectTab: Tab,
  selectOption: string,
  pageSize: number,
  page: number,
}

export const order = createModel({
  state: {
    pageSize: 20,
    page: 1,
  } as OrderState,
  reducers: {
    setConfigure: (state, payload: Configure): OrderState => ({
      ...state,
      configure: payload
    }),
    setSelectTab: (state, payload: Tab): OrderState => ({
      ...state,
      selectTab: payload
    }),
    setSelectOption: (state, payload: string): OrderState => ({
      ...state,
      selectOption: payload
    }),
    setPageSize: (state, payload: number): OrderState => ({
      ...state,
      pageSize: payload
    }),
    setPage: (state, payload: number): OrderState => ({
      ...state,
      page: payload
    })
  }
})